var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"share-btn",on:{"click":_vm.click}},[_c('icon',{staticStyle:{"margin-right":"5px"},attrs:{"type":"wechat","width":"16","height":"16"}}),_vm._v(_vm._s(_vm.$t('SHARE_BY_WECHAT')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }